<template>
    <div class="p-grid">
        <div class="p-col-12">             
            <Toolbar class="p-mb-4">
                <template slot="left">						
                    <Button type="button" icon="pi pi-plus" label="Novo" class="p-mr-2" @click="exibirModalMenuNovo"/>
                    <Button type="button" icon="pi pi-pencil" label="Editar" class="p-mr-2" 
                        :disabled="menuSelecionado == null" @click="exibirModalMenuEditar"/>
                    <Button type="button" icon="pi pi-sort-alt" label="Mover" class="p-mr-2" 
                        :disabled="menuSelecionado == null" @click="exibirModalMenuDestino"/>
                    <div v-if="menuSelecionado != null">
                        <Button type="button" icon="pi pi-times" label="Desativar" class="p-mr-2 p-button-warning" 
                            v-if="menuSelecionado.original.ativo" @click="exibirDialogConfirmarStatusAtivo=true"/>		
                        <Button type="button" icon="pi pi-check" label="Ativar" class="p-mr-2" 
                            v-if="!menuSelecionado.original.ativo" @click="exibirDialogConfirmarStatusAtivo=true"/>
                        <Button type="button" icon="pi pi-trash" label="Excluir" class="p-mr-2 p-button-danger" 
                            v-if="!menuSelecionado.original.publicado" @click="exibirDialogConfirmarExcluir=true"/>
                    </div>								
                </template>					
            </Toolbar>            
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-4">                          
                    <ScrollPanel style="width: 100%; height: 500px">
                        <Tree :value="itensMenu" :filter="true" filterMode="lenient" selectionMode="single" :selectionKeys.sync="idMenuSelecionado"
                            @node-select="selecionarMenu">
                            <template #default="slotProps">
                                {{slotProps.node.label}}
                            </template>
                            <template #novo="slotProps">
                                <b>{{slotProps.node.label}}</b>
                            </template>
                            <template #desativado="slotProps">
                                <span style="color:#C13928"> {{slotProps.node.label}}</span>
                            </template>
                        </Tree>
                    </ScrollPanel>                        
                </div>
                <div class="p-field p-col-12 p-md-8" v-if="exibirPermissoes">
                    <label>Permissões - {{ menuSelecionado.label }}</label>
                    <Listbox :options="permissoesItemMenuSelecionado" optionLabel="descricao" />                        
                </div>                
            </div>                             
        </div>

        <Dialog :visible.sync="exibirDialogMenu" :header="tituloEdicaoMenu" :modal="true" class="p-fluid" :style="{width: '500px'}" @hide="fecharModal"> 
            <FormMenu ref="formMenu" :receberDados="getDadosSelecionados"/>
            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
                <Button label="Salvar" icon="pi pi-check" @click="salvar"/>
            </template>
        </Dialog>

        <Dialog :visible.sync="exibirDialogMenuMover" header="Mover Menu" :modal="true" class="p-fluid" :style="{width: '500px'}" @hide="fecharModal"> 
            <div class="p-mb-2">
                <label v-if="menuSelecionado != null">Selecione o destino para {{ menuSelecionado.label }}</label>
            </div>
            <ScrollPanel style="width: 100%; height: 500px">
                <Tree :value="itensMenuDestino" :filter="true" filterMode="lenient" selectionMode="single" :selectionKeys.sync="idMenuDestinoSelecionado"
                    @node-select="selecionarMenuDestino"></Tree>
            </ScrollPanel> 
            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
                <Button label="Salvar" icon="pi pi-check" @click="confirmarMoverMenu"/>
            </template>
        </Dialog>

        <Dialog :visible.sync="exibirDialogConfirmarMover" header="Confirmar" :modal="true" :style="{width: '450px'}">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
                <span>Mover menu?</span>
                <p>
                    <br/>
                    Menu alvo: <b v-if="menuSelecionado != null">{{ menuSelecionado.label }}</b><br/>
                    Menu destino: <b v-if="menuDestinoSelecionado != null">{{ menuDestinoSelecionado.label }}</b>                        
                </p>
            </div>
            <template #footer>
                <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogConfirmarMover=false"/>
                <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="moverMenu" />
            </template>
        </Dialog>

        <Dialog :visible.sync="exibirDialogConfirmarStatusAtivo" header="Confirmar" :modal="true" :style="{width: '450px'}">
            <div class="confirmation-content">                    
                <div v-if="menuSelecionado != null">
                    <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
                    <span v-if="menuSelecionado.original.ativo">Desativar menu?</span>
                    <span v-if="!menuSelecionado.original.ativo">Ativar menu?</span>
                </div>
                <p>
                    <br/>
                    Menu: <b v-if="menuSelecionado != null">{{ menuSelecionado.label }}</b><br/>                                            
                </p>
            </div>
            <template #footer>
                <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogConfirmarStatusAtivo=false"/>
                <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="ativarDesativarMenu" />
            </template>
        </Dialog>

        <Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
            <div class="confirmation-content">                    
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
                <span>Excluir menu?</span>                   
                <p>
                    <br/>
                    Menu: <b v-if="menuSelecionado != null">{{ menuSelecionado.label }}</b><br/>                                            
                </p>
            </div>
            <template #footer>
                <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogConfirmarExcluir=false"/>
                <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluirMenu" />
            </template>
        </Dialog>
    </div>  
</template>

<script>
import FormMenu from '@/components/pages/cadastro/menu/Form.vue';
import MenuService from '@/service/MenuService';
import Menu from '@/model/Menu';
import { exibirMensagem, exibirMensagemSis, clonar } from '@/global';
import { mapGetters } from 'vuex';

export default {
    menuService: null,
    data() {
        return {    
            tituloEdicaoMenu: 'Novo Menu',
            exibirDialogConfirmarExcluir: false,
            exibirDialogConfirmarStatusAtivo: false,
            exibirDialogConfirmarMover: false,
            exibirDialogMenuMover: false,
            exibirDialogMenu: false,   
            exibirPermissoes: false,           
            iteMenuNovo: false,
            idMenuSelecionado: null,
            idMenuDestinoSelecionado: null,
            menuSelecionado: null,
            menuDestinoSelecionado: null,
            permissoesItemMenuSelecionado: [],             
            itensMenu:[],      
            itensMenuDestino:[],      
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),       
        salvar() {           
            let dados = this.$refs.formMenu.getDados();    
            if(dados == null) {
                return null;
            }      
            // Menu novo é um menu ativo mas não publicado (relacionou com o perfil de um plano ou usuári(s))
            let menuPai = null;                
            dados.menuFilho.permissoes = clonar(dados.permissoesAtivasNovas)
                                        .concat(clonar(dados.permissoesDesativadas));
            if(!dados.isPrincipal) {
                menuPai = {...dados.menuPai};
            }
            let requisicao = {
                menu: {...dados.menuFilho},
                menuPai: menuPai,
                permissoesExcluir: clonar(dados.permissoesExcluir),
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }
            this.menuService.salvar(requisicao)
                .then(resp => {			
                    this.fecharModal();
                    exibirMensagem(this, resp); 
                    this.listar();
                    this.reset();
                })
                .catch(erro => {exibirMensagem(this, erro)}); 
        },
        moverMenu() {
            let requisicao = {
                permissoesExcluir: [],
                menu: {...this.menuSelecionado.original},
                menuPai: {...this.menuDestinoSelecionado.original},
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }
            this.menuService.salvar(requisicao)
                .then(resp => {			
                    this.fecharModal();
                    exibirMensagem(this, resp); 
                    this.listar();
                    this.reset();
                })
                .catch(erro => {exibirMensagem(this, erro)}); 
        },
        ativarDesativarMenu() {
            let requisicao = {
                menu: {...this.menuSelecionado.original},
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }
            this.menuService.atualizarStatusAtivo(requisicao)
                .then(resp => {			
                    this.exibirDialogConfirmarStatusAtivo = false;
                    exibirMensagem(this, resp); 
                    this.listar();
                    this.reset();
                })
                .catch(erro => {exibirMensagem(this, erro)}); 
            
        },
        excluirMenu() {
            let requisicao = {
                menu: {...this.menuSelecionado.original},
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }
            this.menuService.excluir(requisicao)
                .then(resp => {			
                    this.exibirDialogConfirmarExcluir = false;
                    exibirMensagem(this, resp); 
                    this.listar();
                    this.reset();
                })
                .catch(erro => {exibirMensagem(this, erro)}); 
        },
        listar() {
            this.menuSelecionado = null;
            this.exibirPermissoes = false;
            let requisicao = {
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }	
            this.menuService.listar(requisicao)
				.then(resp => {			
					this.itensMenu = this.converterMenu(resp.data);	
                })
                .catch(erro => {exibirMensagem(this, erro)});            
        } ,
        converterMenu(menu) {
            let itens = [];
            menu.forEach(me => {
                me.permissoes.forEach(perm => {
                    let tipo = '';
                    if(!perm.publicado) {
                        tipo = ' (Novo)';
                    }
                    if(!perm.ativo) {
                        tipo = ' (Desativado)';
                    }  
                    perm['descricao'] = perm.codigo+' - '+perm.nome+' - '+perm.nomeOperacao+tipo;
                });
                let type = 'default';
                if(!me.publicado) {
                    type = 'novo';
                }
                if(!me.ativo) {
                    type = 'desativado';
                }                
                let objMenu = {
                    key: me.id,
                    label: me.nome,
                    data: me.nome,
                    icon: (me.menuFilhos.length == 0 ? 'pi pi-fw pi-tags' : ''),
                    type: type,
                    children: (me.menuFilhos.length > 0 ? this.converterMenu(me.menuFilhos) : []),
                    original: me,
                }
                itens.push(objMenu);
            });
            return itens;
        },  
        selecionarMenu(menu) {          
            this.menuSelecionado = menu;
            this.permissoesItemMenuSelecionado = menu.original.permissoes;            
            this.exibirPermissoes = true;
        },  
        selecionarMenuDestino(menu) {          
            this.menuDestinoSelecionado = menu;           
        },     
        exibirModalMenuEditar() {          
            this.tituloEdicaoMenu = 'Editar Menu';      
            this.iteMenuNovo = false;   
            this.exibirDialogMenu = true;            
        },
        exibirModalMenuNovo() {   
            this.tituloEdicaoMenu = 'Novo Menu';     
            this.iteMenuNovo = true;        
            this.exibirDialogMenu = true;            
        },
        exibirModalMenuDestino() {
            this.itensMenuDestino = clonar(this.itensMenu);
            this.exibirDialogMenuMover = true;
        },
        getDadosSelecionados() {       
            let menuPai = null;
            let menuFilho = null;   
            let permissoesAtivasNovas = [];
            let permissoesDesativadas = [];
            if(this.iteMenuNovo) {
                menuPai = (this.menuSelecionado != null ? this.menuSelecionado.original : new Menu());
            } else  {
                menuPai = this.menuSelecionado.original.menuPai;
                menuFilho = this.menuSelecionado.original;
                menuFilho.permissoes.forEach(perm => {
                    if(perm.ativo) {
                        permissoesAtivasNovas.push({...perm});
                    } else {
                        permissoesDesativadas.push({...perm});
                    }
                });
            }            
            let dadosMenuEdicao = {               
                menuPai: menuPai,
                menu: menuFilho,
                permissoesAtivasNovas: permissoesAtivasNovas,
                permissoesDesativadas: permissoesDesativadas,
            }            
            return dadosMenuEdicao;
        },        
        confirmarMoverMenu() {
            if(this.menuDestinoSelecionado == null) {
                exibirMensagemSis(this, 'Selecione o menu de destino', true);
                return;
            }
            if(this.menuDestinoSelecionado.original.id == this.menuSelecionado.original.id) {
                exibirMensagemSis(this, 'Selecione um destino diferente do alvo', true);
                return;
            }
            this.exibirDialogConfirmarMover = true;
        },
        reset() {
            this.exibirPermissoes = false;          
            this.idMenuSelecionado = null;
            this.idMenuDestinoSelecionado = null;
            this.menuDestinoSelecionado = null;
            this.menuSelecionado = null;
            this.permissoesItemMenuSelecionado = []; 
        },
        fecharModal() {
            this.exibirDialogMenu = false;   
            this.exibirDialogMenuMover = false;
            this.exibirDialogConfirmarMover = false;
            this.menu = new Menu();
        }   
    },
    created() {
        this.menuService = new MenuService();
    },
    mounted() {
        this.listar();
    },
    components: {
		'FormMenu': FormMenu,		
    }
}
</script>

<style>
</style>